import React from "react";
import Image from "../../../elements/Image";
import { classNames } from "../../../../helpers/classNames";

const TextWithImageBlock = ({ data, imageFirst = false, bgColor }) => {
  return (
    <>
      <section className="relative flex w-full py-16 xls:py-24 bg-white">
        <div className="w-full sm:max-w-xl md:max-w-2xl lg:max-w-4xl xls:max-w-6xl xl:max-w-7xl 2xl:max-w-8xl 3xl:max-w-9xl mx-auto px-4">
          <div className="space-y-10 sm:space-y-16">
            {data?.title && <h2 className="text-3xl sm:text-4xl xls:text-[42px] font-bold text-center">{data?.title}</h2>}
            <div className={classNames("relative w-full lg:flex", bgColor, imageFirst ? "flex-row-reverse" : "flex-row")}>
              <div className="w-full lg:w-[45%] xls:w-[54%] flex py-8 xls:py-16 px-8 xls:px-12">
                <div
                  className="text-base xls:text-xl font-Gotham font-medium !leading-loose text-white first-letter:font-CanelaDeck first-letter:text-5xl xls:first-letter:text-7xl first-letter:font-semibold"
                  dangerouslySetInnerHTML={{ __html: data?.description }}
                />
              </div>
              <div className="w-full lg:w-[55%] xls:w-[46%] flex">
                {data?.image && (
                  <div className="w-full overflow-hidden flex">
                    <Image src={data?.image} alt={""} effect="blur" classes="object-cover" />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default TextWithImageBlock;
